import React, { Component } from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import MealCell from '~/glm/components/guest-list/cells/meal-cell.jsx';
import GdsUiState from '~/glm/models/gds/gds-ui-state';
import GdsInvitationModel from '~/glm/models/gds/gds-invitation-model';
import AnalyticsStore from '~/glm/models/analytics-store';
import CustomQuestion from '~/glm/models/gds/gds-custom-question-model';
import styles from './meals-cell.scss';

@observer
class MealsCell extends Component {
  static propTypes = {
    invitations: PropTypes.arrayOf(PropTypes.instanceOf(GdsInvitationModel)),
    gdsUiState: PropTypes.instanceOf(GdsUiState),
    trackMeal: PropTypes.func,
    mealQuestion: PropTypes.instanceOf(CustomQuestion).isRequired,
    disabled: PropTypes.bool,
    analyticsStore: PropTypes.instanceOf(AnalyticsStore),
  };

  state = {
    isEditing: false,
  };

  render() {
    const { invitations, trackMeal, gdsUiState, analyticsStore, disabled = false } = this.props;
    const containerStyle = disabled ? styles.disabledMembersContainer : styles.householdMembersContainer;

    return (
      <td className={containerStyle}>
        {invitations.map(invitation => (
          <MealCell
            trackMeal={trackMeal}
            key={invitation.id}
            invitation={invitation}
            gdsUiState={gdsUiState}
            analyticsStore={analyticsStore}
            mealQuestion={this.props.mealQuestion}
            meal={invitation.meal}
            disabled={disabled}
          />
        ))}
      </td>
    );
  }
}

export default MealsCell;
